<template>
    <div id="app" :class="{cn: lang === 'cn', en: lang === 'en'}">
        <base-layout>
            <template v-slot:header>
                <custom-header
                        :logoHeader="logoHeader"
                        :navs="navs"
                        :activeIndex="activeIndex"
                        @changeNav="changeNav"></custom-header>
            </template>
            <template v-slot:default>
                <transition name="fade">
                    <router-view>
                    </router-view>
                </transition>
            </template>
            <template v-slot:footer>
                <custom-footer :customerService="footer.customerService"
                               :legalProvision="footer.legalProvision"
                               :socialContact="footer.socialContact"
                               :logoFooter="footer.logoFooter"
                               :companyInfo="footer.companyInfo">
                </custom-footer>
            </template>
        </base-layout>
    </div>
</template>

<script>
    import BaseLayout from './components/layout/BaseLayout'
    import CustomHeader from './components/layout/CustomHeader'
    import CustomFooter from './components/layout/CustomFooter'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'app',
        components: {
            BaseLayout,
            CustomHeader,
            CustomFooter,
        },
        data() {
            return {
                activeIndex: 0,
                lang: 'cn',
            }
        },
        computed: {
            ...mapState('common', {
                wechat_share_default_description:state => state.wechat_share_default_description,
                wechat_share_default_image:state => state.wechat_share_default_image,
                wxShare: state => state.wxShare,
                navs: state => {
                    return state.navs.map(nav => {
                        return {
                            href: nav.href,
                            text: nav.title,
                            to: nav.href,
                        }
                    })
                },
                logoHeader: state => {
                    if (state.theme === 'dark') {
                        return {
                            logo: state.logo_dark
                        }
                    } else {
                        return {
                            logo: state.logo_light
                        }
                    }
                },
                footer: ({footer, logo}) => {
                    return {
                        customerService: {
                            title: footer.footer_nav.length && footer.footer_nav[0].title,
                            items: footer.footer_nav.length && footer.footer_nav[0].items,
                        },
                        legalProvision: {
                            title: footer.footer_nav.length && footer.footer_nav[1].title,
                            items: footer.footer_nav.length && footer.footer_nav[1].items,
                        },
                        socialContact: {
                            title: footer.footer_nav.length && footer.footer_nav[2].title,
                            items: footer.footer_nav.length && footer.footer_nav[2].items,
                        },
                        logoFooter: {
                            text: '© ' + footer.year,
                            logo: logo
                        },
                        companyInfo: {
                            copyright: footer.footer_text.copyright + ' ',
                            address: footer.footer_text.address + ' | ',
                            telephone: footer.footer_text.telephone + ' | ',
                            icpText: footer.footer_text.icp_text,
                            icpHref: footer.footer_text.icp_href,
                            otherText: ' ' + footer.footer_text.other_text,
                            text2: 'IICOMBINED Co., Ltd.保留所有权利 上海市闵行区万源路2163号新桥商务中心 A幢 3A层 | Tel : 400 606 7070 | 沪ICP备16001110号 DOVETAIL官方网站由上海卯时科技有限公司管理运营。'
                        }
                    }
                }
            })
        },
        watch: {
            navs: {
                handler(navs) {
                    if (Array.isArray(navs)) {
                        navs.forEach((nav, index) => {
                            if (nav.to === this.$route.path) {
                                this.activeIndex = index
                            }
                        })
                    }
                },
                isDeep: true
            },
            $route: {
                handler(to){
                    if (to.path === '/') {
                        this.activeIndex = 0
                    } else if (to.path.indexOf('/fine_jewelry') !== -1) {
                        this.activeIndex = 1
                    } else if (to.path.indexOf('/fashion_jewelry') !== -1) {
                        this.activeIndex = 2
                    } else if (to.path.indexOf('/stories') !== -1) {
                        this.activeIndex = 3
                    } else if (to.path.indexOf('/purchase') !== -1) {
                        this.activeIndex = 4
                    } else if (to.path.indexOf('/service') !== -1) {
                        this.activeIndex = 5
                    } else {
                        this.activeIndex = 100
                    }
                },
                deep: true,
            }
        },
        methods: {
            ...mapActions('common', ['getCommonConfig']),
            changeNav({index, nav}) {
                this.activeIndex = index
                this.$router.push({
                    path: nav.to
                })
            },
        },
        created() {
            this.getCommonConfig()
            if (localStorage.getItem('lang')) {
                this.lang = localStorage.getItem('lang')
            }
        },
        metaInfo() {
            return {
                meta: [{
                    property: 'og:title',
                    content: this.wxShare.title || document.title,
                },{
                    property: 'og:type',
                    content: 'website'
                },{
                    property: 'og:url',
                    content: location.href
                },{
                    property: 'og:image',
                    content: this.wxShare.imgUrl || this.wechat_share_default_image, // 分享图标
                },{
                    property: 'og:site_name',
                    content: 'DOVETIAL Official Site'
                }]
            }
        }
    }
</script>

<style>
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #000;
        min-width: 1200px;
    }

    .cn {
        font-family: SourceHanSans-Normal, Helvetica, Arial, sans-serif;
    }

    .en {
        font-family: Montserrat-Light, Helvetica, Arial, sans-serif;
    }
</style>
